import React from 'react'
import { Alert } from 'react-bootstrap'
import PropTypes from 'prop-types';

export const SkuMessageError = ({ message }: any) => {

    return (
        <Alert variant="danger" className="mr-4 ml-4">
            <div className="text-center">{message}</div>
        </Alert>
    )

}

SkuMessageError.propTypes = {
    message: PropTypes.string.isRequired
}